import {
  Typography,
  MenuItem,
  Menu,
  Fade,
  createTheme,
  ThemeProvider,
  Link,
} from "@mui/material";
import { useEffect, useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import {  getOrgType } from "../../utils/Token";

const theme = createTheme({
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          left: "80px",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          left: "80px",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          top: "-5%",
          left: "39px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          boxShadow: "unset",
          border: "solid 1px #f6f6f6",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          minWidth: "10rem",
          minHeight: "14px",
          lineHeight: 1.1,
          fontFamily: "Inter Regular",
          fontSize: "0.9rem",
          textTransform: "none",
          ":hover": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        subtitle2: {
          fontFamily: "Inter SemiBold",
        },
        root: {
          padding: "0 1rem",
        },
      },
    },
  },
});

export default function SideMenuPopup({
  title,
  items,
  anchorEl,
  showPopup,
  propagatePopupClose,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(showPopup);
  }, [showPopup]);

  function handleClose() {
    propagatePopupClose();
  }

  return (
    <ThemeProvider theme={theme} >
      {anchorEl && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
          MenuListProps={{ onMouseLeave: handleClose }}
          sx={{marginTop:(title=="My Account"&&getOrgType()=="Admin")?"40px":""}}

        >
          <Typography variant="subtitle2" textTransform="uppercase" >
            {title == "My Account"?"Settings":title}
          </Typography>
          {/* {items.map((item) => (
            <MenuItem key={item.menuName} onClick={handleClose}>
              <Link
                component={RouterLink}
                to={`/${item.actionName}`}
                underline="none"
                color={theme.palette.text.primary} 
                sx={{
                  paddingLeft: "0",
                  ":hover": { color: theme.palette.info.main },
                }}
                style={({ isActive }) =>
                  isActive ? { color: theme.palette.text.disabled } : undefined
                }
              >
                {item.menuDisplayname}
              </Link>
            </MenuItem>
          ))} */}
          {items?.map((item) => (
              <Link
                key={item?.menuName}
                component={RouterLink}
                to={`/${item?.actionName}`}
                underline="none"
                color={theme.palette.text.primary} 
                sx={{
                  paddingLeft: "0",
                  padding:"0",
                  ":hover": { color: theme.palette.info.main },
                  width:"100%",
              

                }}
                style={({ isActive }) =>
                  isActive ? { color: theme.palette.text.disabled } : undefined
                }
              >
                            <MenuItem   onClick={handleClose} hidden={item?.menuName=="ChangePassword"||item?.menuName=="CompanyDetails"||item?.menuName=="MyAccount"}>

                {item?.menuDisplayname}
                </MenuItem>
              </Link>
      
          ))}
        </Menu>
      )}
    </ThemeProvider>
  );
}
